import { render, staticRenderFns } from "./AddProjectStep3.vue?vue&type=template&id=3dc91b04&scoped=true&"
import script from "./AddProjectStep3.vue?vue&type=script&lang=js&"
export * from "./AddProjectStep3.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectStep3.vue?vue&type=style&index=0&id=3dc91b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc91b04",
  null
  
)

export default component.exports